import { render } from "./Inserir.vue?vue&type=template&id=caaef3c2"
import script from "./Inserir.vue?vue&type=script&lang=js"
export * from "./Inserir.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__